import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {QuestionStatus} from '@cp/model';
import {env} from '../../config/env';

export interface DropdownQuestionStatusProps {
  status?: QuestionStatus;
  /** change of status, undefined/null means any status */
  onChange: (status?: QuestionStatus) => void;
  /** Whether to show "All Statuses" option (for optional status) */
  allowAll?: boolean;
  /** Filter available statuses (e.g., for reviewers) */
  availableStatuses?: QuestionStatus[];
  /** Disable the dropdown */
  disabled?: boolean;
  /** Full width control */
  fullWidth?: boolean;
  /** Minimum width */
  minWidth?: number;
}

export default function DropdownQuestionStatus({
  status,
  onChange,
  allowAll = false,
  availableStatuses,
  disabled = false,
  fullWidth = true,
  minWidth,
}: DropdownQuestionStatusProps) {
  const statuses = availableStatuses || Object.values(QuestionStatus);
  const displayValue = status || '';

  return (
    <FormControl fullWidth={fullWidth} sx={minWidth ? {minWidth} : undefined} data-testid="dropdown-question-status">
      <InputLabel>Status</InputLabel>
      <Select
        value={displayValue}
        onChange={(e) => onChange(e.target.value ? (e.target.value as QuestionStatus) : undefined)}
        label="Status"
        disabled={disabled}
      >
        {allowAll && (
          <MenuItem value="">
            <em>All Statuses</em>
          </MenuItem>
        )}
        {statuses.map((statusValue) => (
          <MenuItem key={statusValue} value={statusValue}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  bgcolor: env.question.status[statusValue]?.color || env.question.unknownStatus.color,
                }}
              />
              {env.question.status[statusValue]?.label || env.question.unknownStatus.label}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
